import React from 'react';
import styles from './LineChip.module.css';

interface LineChipProps {
  lineNumber: string;
  size?: 'small' | 'normal' | 'large';
  onClick?: () => void;
  className?: string;
  lineColor?: string; // Hat için özel renk kodu (hex formatında)
}

// Renk koyu mu açık mı kontrol eden yardımcı fonksiyon
function isColorDark(hexColor: string): boolean {
  if (!hexColor || !hexColor.startsWith('#') || hexColor.length !== 7) {
    return false;
  }
  
  try {
    // Hex rengi RGB'ye çevir
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    
    // Parlaklık hesapla (HSP renk modeli)
    // Kaynak: https://stackoverflow.com/a/58270940
    const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
    
    // hsp değeri 127.5'den küçükse renk koyu, değilse açık
    return hsp < 127.5;
  } catch (e) {
    console.error('Renk dönüşümü sırasında hata:', e);
    return false;
  }
}

/**
 * Hat numarası gösteren bileşen
 * @param lineNumber - Hat numarası (Örn: "5", "530", "31A" vb.)
 * @param size - Bileşenin boyutu (small, normal, large)
 * @param onClick - Tıklama işlevi (opsiyonel)
 * @param className - Ek CSS sınıfı (opsiyonel)
 * @param lineColor - Hat için özel renk kodu (opsiyonel)
 */
const LineChip: React.FC<LineChipProps> = ({ 
  lineNumber, 
  size = 'normal', 
  onClick, 
  className = '',
  lineColor
}) => {
  // Bileşenin boyutunu belirle
  const sizeClass = styles[size] || styles.normal;
  
  // Tıklanabilir mi?
  const isClickable = typeof onClick === 'function';
  
  // Stil özelliklerini oluştur
  const style: React.CSSProperties = {};
  if (lineColor) {
    style.backgroundColor = lineColor;
    // Renk koyu ise metin rengini aç
    if (isColorDark(lineColor)) {
      style.color = '#ffffff';
    } else {
      style.color = '#333333';
    }
  }
  
  return (
    <div 
      className={`${styles.lineChip} ${sizeClass} ${isClickable ? styles.clickable : ''} ${className}`}
      onClick={isClickable ? onClick : undefined}
      style={style}
    >
      {lineNumber}
    </div>
  );
};

export default LineChip;
